import { useCallback, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchExternal } from "../utils/fetch";
import { UserGlobalContextMemorySpace } from "../contexts/user/userGlobalContext";

const MAINTENANCE_POLL_INTERVAL_MS = 60000;

export const shouldShowMaintenanceModal = (pathname) => {
  if (pathname.startsWith("/micrositio")) {
    return false;
  }

  if (pathname === "/cerrar-sesion") {
    return false;
  }

  return true;
};

export const useMaintenanceBanner = () => {
  const { user, sitePSHB } = useContext(UserGlobalContextMemorySpace);
  const location = useLocation();
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  const idEmpresa = sitePSHB ? 2 : 1;
  const pathname = location.pathname;

  useEffect(() => {
    setDismissed(false);
  }, [pathname]);

  const fetchBanner = useCallback(async () => {
    if (!user?.user?.data) {
      setBanner(null);
      return;
    }

    try {
      const url = `${process.env.REACT_APP_STRAPI_QA}/banner-mantenimientos/activo?idEmpresa=${idEmpresa}&canal=web`;
      const { data } = await fetchExternal(url, "GET");

      if (!data?.id) {
        setBanner(null);
        return;
      }

      setBanner(data);
    } catch {
      setBanner(null);
    }
  }, [user, idEmpresa]);

  useEffect(() => {
    fetchBanner();
  }, [fetchBanner, pathname]);

  useEffect(() => {
    if (!user?.user?.data) {
      return undefined;
    }

    const intervalId = setInterval(() => {
      fetchBanner();
    }, MAINTENANCE_POLL_INTERVAL_MS);

    return () => clearInterval(intervalId);
  }, [user, fetchBanner]);

  const dismiss = useCallback(() => {
    setDismissed(true);
  }, []);

  const visible =
    Boolean(banner) &&
    shouldShowMaintenanceModal(pathname) &&
    !dismissed;

  return { banner, visible, dismiss, refetch: fetchBanner };
};
